import { Component, OnInit, AfterViewInit, AfterViewChecked, AfterContentInit } from '@angular/core';
import { GetUserMenuService, CommonService, PatientPortalDemographicsService, DataSharingService, ConfirmDialogService, GetPatientPortalStatementMenuService, GetPatientPortalFormsService, GetPatientEducationalResourcesService, GetVisitNotesService, GetPracticeMessagesService, PracticeCloudStorageService, ClipBoardService } from '../services/api';
import { environment } from '../../environments/environment';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { PatientPortalStatementMenu, PatientPortalFormData, PatientEducationalResourceListData, PatientPortalEMRViewNoteData, PatientPortalLoggedInUserList, PracticeMessages } from '../model/models';
import { DatePipe } from '@angular/common';
import { transcode } from 'buffer';
import { NgxSpinnerService } from 'ngx-spinner';
import PerfectScrollbar from 'perfect-scrollbar';

//Metadata
declare var $: any;
export interface RouteInfo {
    path: string;
    title: string;
    type: string;
    collapse?: string;
    icontype: string;
    // icon: string;
    children?: ChildrenItems[];
}

export interface ChildrenItems {
    path: string;
    title: string;
    ab: string;
    type?: string;
}

//Menu Items
export const ROUTES: RouteInfo[] = [{
    path: '/dashboard',
    title: 'Dashboard',
    type: 'link',
    icontype: 'nc-icon nc-bank',
    children: []
}

];

@Component({
    moduleId: module.id,
    selector: 'sidebar-cmp',
    templateUrl: 'sidebar.component.html',
})

export class SidebarComponent implements OnInit {


    public menuItems: any[] = [];
    public childItems: any[] = [];
    public chChildItems: any[] = [];
    public userName: string;
    public patientImage: any;
    public patientForms: PatientPortalFormData[] = [];
    public edList: PatientEducationalResourceListData[] = [];
    public visitDates: PatientPortalEMRViewNoteData[] = [];
    public subIcon: string;
    userList: any;
    isAuthUser: boolean = false;
    selectedPt: number = 0;
    selectedPractice: string = '';
    encVal: any;
    Header: string = '';
    Logo: string = '';
    todoCount: number = 0;
    public icons = [
        'sidemenu-icon-dashboard', 'sidemenu-icon-messageboard', 'sidemenu-icon-clinical', 'sidemenu-icon-financial',
        'sidemenu-icon-patientform', 'sidemenu-icon-edresource', 'sidemenu-icon-patientform', 'sidemenu-icon-clipboard', 'sidemenu-icon-oralimmuno'
    ]
    public childIcons = [
        'message-icon-inbox', 'message-icon-sent', 'message-icon-draft', 'message-icon-archive', 'clinical-icon-clinicalsummary',
        'clinical-icon-medical', 'clinical-icon-medications', 'clinical-icon-drugallergies', 'clinical-icon-labresults', 'clinical-icon-skintest', 'clinical-icon-immunization', 'clinical-icon-visit', 'clinical-icon-appointments',
        'finance-icon-statement', 'finance-icon-payment', 'finance-icon-receipt'
    ]
    public statementMenu: PatientPortalStatementMenu[] = [];
    public AlertData: PracticeMessages[] = [];
    constructor(private menuService: GetUserMenuService, private tokenService: CommonService, private demService: PatientPortalDemographicsService, private router: Router, private imageUpdate: DataSharingService, private confirmBox: ConfirmDialogService, private stmenuService: GetPatientPortalStatementMenuService, public datepipe: DatePipe, private formService: GetPatientPortalFormsService, private edService: GetPatientEducationalResourcesService, private alertService: GetPracticeMessagesService, private visitService: GetVisitNotesService, private spinner: NgxSpinnerService, private cloudService: PracticeCloudStorageService, private clipboardService: ClipBoardService) {
        if (environment.appSetting.prodType == 'CVN') {
            this.Header = 'CVN Patient'
            this.Logo = './assets/icons/cvn-logo.png';
        }
        else
            if (environment.appSetting.prodType == 'OIT') {
                this.Header = 'OIT Patient'
                this.Logo = './assets/icons/oit-trans.png';
            }
            else {
                this.Header = 'Patient Portal'
                this.Logo = './assets/icons/logo-new.png';

            }
    }
    isNotMobileMenu() {
        if (window.outerWidth > 991) {
            return false;
        }
        return true;
    }

    ngOnInit() {
        //this.patientImage = environment.PatientImage;
        let userCred = localStorage.getItem('userVal');
        var CryptoJS = require("crypto-js");
        var SECRET_KEY = 'm@duLeMD#2k19';
        let decrVal = CryptoJS.AES.decrypt(userCred, SECRET_KEY);
        decrVal = decrVal.toString(CryptoJS.enc.Utf8);
        let userData = JSON.parse(localStorage.getItem('usersession'));
        this.tokenService.GetPortalKey(decrVal.split(',')[0], decrVal.split(',')[1]);
        //this.menuItems = ROUTES.filter(menuItem => menuItem);
        let context: { [key: string]: string } = {};
        this.selectedPt = userData[0].PatientId;
        this.selectedPractice = userData[0].PracticeName;
        context["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
        this.stmenuService.configuration.apiKeys = context;
        this.stmenuService.configuration.accessToken = environment.portalAccessKey;
        this.stmenuService.getPatientPortalStatementMenu(userData[0].PatientId).subscribe(async statements => {
            this.statementMenu = await statements;

            this.tokenService.GetPortalKey(decrVal.split(',')[0], decrVal.split(',')[1]);
            let context1: { [key: string]: string } = {};
            context1["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
            this.formService.configuration.apiKeys = context1;
            this.formService.configuration.accessToken = environment.portalAccessKey;
            this.formService.getPatientPortalForms(userData[0].PatientId).subscribe(async forms => {
                this.patientForms = await forms;

                this.alertService.configuration.apiKeys = context1;
                this.alertService.configuration.accessToken = environment.portalAccessKey;
                this.alertService.GetPracticeLoginMessages().subscribe(async items => {
                    this.AlertData = await items;

                    this.visitService.configuration.apiKeys = context1;
                    this.visitService.configuration.accessToken = environment.portalAccessKey;
                    this.visitService.GetVisitNotes(userData[0].PatientId, false).subscribe(async vs => {
                        this.visitDates = await vs;

                        this.clipboardService.configuration.apiKeys = context1;
                        this.clipboardService.configuration.accessToken = environment.portalAccessKey;
                        this.clipboardService.getPatientAssignedClipboardsInfo(userData[0].PatientId, 1).subscribe(async resultData => {
                            this.todoCount = await resultData.length;

                            let context2: { [key: string]: string } = {};
                            context2["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.PracticeID + "'}";
                            this.edService.configuration.apiKeys = context2;
                            this.edService.configuration.accessToken = environment.portalAccessKey;
                            let headerContext: { [key: string]: string } = {};
                            headerContext["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.PracticeID + "'}";
                            this.menuService.configuration.apiKeys = headerContext;
                            this.menuService.configuration.accessToken = environment.portalAccessKey;
                            this.menuService.getUserMenu().subscribe(async data => {
                                await data.forEach(mf => {
                                    if (mf.ParentID == 0 && mf.MenuText != 'My Account') {
                                        if (mf.MenuText == 'Patient Forms')
                                            this.menuItems.push({ 'menuid': mf.MenuID, 'path': mf.MenuText.toLowerCase(), 'title': mf.MenuText, 'collapse': 'patientforms', 'type': 'sub', 'icontype': '', 'children': [] });
                                        else
                                            this.menuItems.push({ 'menuid': mf.MenuID, 'path': (mf.MenuText == 'Educational Resources') ? 'educationalresources' : (mf.MenuText == 'Oral Immunotherapy') ? 'immunotherapy' : mf.MenuText.toLowerCase(), 'title': mf.MenuText, 'collapse': mf.MenuText, 'type': (mf.MenuText == 'Dashboard' || mf.MenuText == 'Documents' || mf.MenuText == 'Educational Resources' || mf.MenuText == 'Oral Immunotherapy') ? 'link' : 'sub', 'icontype': '', 'children': [] });
                                    }
                                });
                                let incr: number = 0;
                                this.menuItems.forEach((ch, i) => {
                                    ch.icontype = this.icons[i];
                                    if (ch.menuid == 1) {
                                        if (this.AlertData.length > 0)
                                            this.childItems.push({ 'path': 'notification', 'title': 'Notification', 'ab': 'message-icon-notification', nxtchild: [], 'hrefid': '' });
                                    }
                                    if (ch.path == 'patient forms') {
                                        this.patientForms.forEach((frmenu) => {
                                            ch.children.push({ 'path': frmenu.FormName, 'title': frmenu.FormName + '~' + frmenu.Id + '~' + frmenu.FormId, 'id': frmenu.Id, 'FormId': frmenu.FormId, 'ab': '', nxtchild: [], 'actpath': 'patientforms' });
                                        });
                                    }
                                    if (ch.path == 'clipboards') {
                                        if (this.todoCount > 0) {
                                            this.childItems.push({ 'path': 'todolist', 'title': 'My To-Do List', 'ab': 'fa fa-list-alt', nxtchild: [], 'hrefid': '' });
                                            this.childItems.push({ 'path': 'completed', 'title': 'Completed', 'ab': 'fa fa-th-list', nxtchild: [], 'hrefid': '' });
                                        }
                                        else
                                            this.menuItems.splice(i, 1);

                                    }
                                    data.forEach((mfch, j) => {
                                        if (ch.menuid == mfch.ParentID) {
                                            if (mfch.MenuText != 'Generate PDF Report') {

                                                if (mfch.MenuURL == 'PatientSatement') {
                                                    this.chChildItems = [];
                                                    this.statementMenu.forEach((stmenu) => {
                                                        this.chChildItems.push({ 'id': stmenu.StatementID, 'path': 'statement', 'title': this.datepipe.transform(stmenu.StatementDate, 'MM/dd/yyyy'), 'ab': '' });
                                                    });
                                                    this.childItems.push({ 'path': '', 'title': mfch.MenuText, 'ab': this.childIcons[incr], nxtchild: this.chChildItems, 'hrefid': 'statements' });
                                                    this.subIcon = 'finance-icon-statement';
                                                }
                                                else
                                                    if (mfch.MenuURL == 'VisitSummary') {
                                                        this.chChildItems = [];
                                                        this.subIcon = 'clinical-icon-visit';
                                                        this.visitDates.forEach((vs) => {
                                                            if (vs.SendToPatientPortal == true || vs.DictationotesSendToPatientPortal == true) {
                                                                let vsId = 0;
                                                                if (vs.SendToPatientPortal == true)
                                                                    vsId = vs.VisitSlip;
                                                                else
                                                                    if (vs.DictationotesSendToPatientPortal == true)
                                                                        vsId = vs.Note_Id;
                                                                this.chChildItems.push({ 'id': vsId, 'path': 'visitsummary', 'title': vs.VisitSlip + "-" + vs.ServiceType + "-" + vs.VisitDate + "-" + vs.ApprovalId + "-" + vs.ApprovalName + "-" + vs.ApprovalDate + "-" + vs.SendToPatientPortal + "-" + vs.DictationotesSendToPatientPortal + "-" + vs.Note_Id, 'ab': '', 'vstitle': vs.VisitDate });
                                                            }
                                                        });
                                                        this.childItems.push({ 'path': '', 'title': mfch.MenuText, 'ab': this.childIcons[incr], nxtchild: this.chChildItems, 'hrefid': 'visits' });
                                                    }
                                                    else
                                                        if (mfch.MenuURL == 'MessageBoard')
                                                            this.childItems.push({ 'path': mfch.MenuText, 'title': mfch.MenuText, 'ab': this.childIcons[incr], nxtchild: [], 'hrefid': '' });
                                                        else
                                                            this.childItems.push({ 'path': mfch.MenuURL.toLowerCase(), 'title': mfch.MenuText, 'ab': this.childIcons[incr], nxtchild: [], 'hrefid': '' });
                                                incr++;
                                            }
                                        }

                                    });
                                    if (ch.path != 'patient forms')//&& ch.path != 'educationalresources'
                                        ch.children = this.childItems;
                                    this.childItems = [];
                                });
                            });
                            let headerContext1: { [key: string]: string } = {};
                            headerContext1["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
                            this.demService.configuration.apiKeys = headerContext1;
                            this.demService.configuration.accessToken = environment.portalAccessKey;
                            this.imageUpdate.result$.subscribe(result => this.patientImage = result);
                            if (this.patientImage) {
                                let el: HTMLImageElement = document.getElementById('imgPatient') as HTMLImageElement;
                                el.src = this.patientImage;
                            }
                            let storageType = localStorage.getItem('storagetype');
                            let isCloudStorage: boolean = storageType.toUpperCase() == 'MODULEMD' ? false : true;

                            this.demService.patientPortalDemographics(userData[0].PatientId).subscribe(items => {
                                let pInf = items.PatientInfo;
                                let ptName = pInf.PatientFirstName + ' ' + pInf.PatientMiddleName + ' ' + pInf.PatientLastName;
                                localStorage.setItem('patientname', ptName);
                                if (this.patientImage == null) {
                                    if (isCloudStorage == false) {
                                        let imageUrl: string = environment.appSetting.patientPicturesFolderPath + environment.UserPracticeId + "/" + items.PatientInfo.FileName;
                                        this.imageExists(imageUrl, function (exists) {
                                            let el: HTMLImageElement = document.getElementById('imgPatient') as HTMLImageElement;

                                            if (exists == false) {
                                                if (el != null)
                                                    el.src = "../../assets/img/faces/joe-gardner-1.jpg";
                                            }
                                            else {

                                                el.src = environment.appSetting.patientPicturesFolderPath + environment.UserPracticeId + "/" + items.PatientInfo.FileName;
                                            }

                                        });
                                        this.patientImage = environment.appSetting.patientPicturesFolderPath + environment.UserPracticeId + "/" + items.PatientInfo.FileName;
                                    }
                                    else {
                                        let container = localStorage.getItem('container');
                                        let configuration = localStorage.getItem('configuration');
                                        let userData = JSON.parse(localStorage.getItem('usersession'));
                                        let headerContextSP: { [key: string]: string } = {};
                                        let supportPortal = 'MMD_COMMON';
                                        headerContextSP["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + supportPortal + "'}";
                                        this.cloudService.configuration.apiKeys = headerContextSP;
                                        this.cloudService.configuration.accessToken = environment.portalAccessKey;

                                        this.cloudService.checkIfFileExistsInCloudStorage(storageType, configuration, container, '', items.PatientInfo.FileName).subscribe(exist => {
                                            if (exist == true) {
                                                this.cloudService.downloadFileFromCloudStorage(storageType, configuration, container, '', items.PatientInfo.FileName).subscribe(fileUrl => {
                                                    var byteCharacters = atob(fileUrl);
                                                    var byteNumbers = new Array(byteCharacters.length);
                                                    for (var i = 0; i < byteCharacters.length; i++) {
                                                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                                                    }
                                                    var byteArray = new Uint8Array(byteNumbers);
                                                    var file = new Blob([byteArray], { type: 'application/jpg;base64' });
                                                    var fileURL = URL.createObjectURL(file);
                                                    let el: HTMLImageElement = document.getElementById('imgPatient') as HTMLImageElement;
                                                    el.src = fileURL;
                                                    console.clear();

                                                });
                                            }
                                        });
                                    }
                                }
                            });
                            // this.isAuthUser = environment.isAuthorizeuser;
                            let authUser = localStorage.getItem('authorizeUser');
                            this.isAuthUser = authUser == 'true' ? true : false;
                            if (this.isAuthUser == true) {
                                this.userList = JSON.parse(localStorage.getItem('userlist'));
                            }
                            else {
                            }
                            this.userName = userData[0].PatientName
                            const elemModal = <HTMLElement>document.querySelector('.patientSelectionModal');
                            elemModal.scrollTop = 0;
                            let ps = new PerfectScrollbar(elemModal);
                        });
                    });
                });
            });
        });
    }
    logout() {
        this.confirmBox.confirmThis("Are you sure you want to Log Off?", () => {
            this.router.navigate(['login']);
        }, function () {
            return false;
        })
    }
    setImage() {
        let userData = JSON.parse(localStorage.getItem('usersession'));
        let storageType = localStorage.getItem('storagetype');
        let isCloudStorage: boolean = storageType.toUpperCase() == 'MODULEMD' ? false : true;
        let headerContext1: { [key: string]: string } = {};
        headerContext1["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + environment.UserPracticeId + "'}";
        this.demService.configuration.apiKeys = headerContext1;
        this.demService.configuration.accessToken = environment.portalAccessKey;
        this.demService.patientPortalDemographics(userData[0].PatientId).subscribe(items => {
            if (isCloudStorage == false) {
                let imageUrl: string = environment.appSetting.patientPicturesFolderPath + environment.UserPracticeId + "/" + items.PatientInfo.FileName;
                this.imageExists(imageUrl, function (exists) {
                    let el: HTMLImageElement = document.getElementById('imgPatient') as HTMLImageElement;

                    if (exists == false) {
                        if (el != null)
                            el.src = "../../assets/img/faces/joe-gardner-1.jpg";
                    }
                    else {

                        el.src = environment.appSetting.patientPicturesFolderPath + environment.UserPracticeId + "/" + items.PatientInfo.FileName;
                    }

                });
                this.patientImage = environment.appSetting.patientPicturesFolderPath + environment.UserPracticeId + "/" + items.PatientInfo.FileName;
            }
            else {
                let container = localStorage.getItem('container');
                let configuration = localStorage.getItem('configuration');
                let userData = JSON.parse(localStorage.getItem('usersession'));
                let headerContextSP: { [key: string]: string } = {};
                let supportPortal = 'MMD_COMMON';
                headerContextSP["Context"] = "{'userid': '" + userData[0].UserId + "','practiceid': '" + supportPortal + "'}";
                this.cloudService.configuration.apiKeys = headerContextSP;
                this.cloudService.configuration.accessToken = environment.portalAccessKey;

                this.cloudService.checkIfFileExistsInCloudStorage(storageType, configuration, container, '', items.PatientInfo.FileName).subscribe(exist => {
                    if (exist == true) {
                        this.cloudService.downloadFileFromCloudStorage(storageType, configuration, container, '', items.PatientInfo.FileName).subscribe(fileUrl => {
                            var byteCharacters = atob(fileUrl);
                            var byteNumbers = new Array(byteCharacters.length);
                            for (var i = 0; i < byteCharacters.length; i++) {
                                byteNumbers[i] = byteCharacters.charCodeAt(i);
                            }
                            var byteArray = new Uint8Array(byteNumbers);
                            var file = new Blob([byteArray], { type: 'application/jpg;base64' });
                            var fileURL = URL.createObjectURL(file);
                            let el: HTMLImageElement = document.getElementById('imgPatient') as HTMLImageElement;
                            el.src = fileURL;
                            console.clear();

                        });
                    }
                });
            }

        });

    }
    imageExists(url, callback) {
        var img = new Image();
        img.onload = function () { callback(true); };
        img.onerror = function () { callback(false); };
        img.src = url;
    }
    selectPatient() {
        //$('#patientSelectionModal').modal("show");
        this.router.navigate(['patientlist']);

    }
    switchPatient(patId) {
        let userData = this.userList.filter(m => m.PatientId === patId);
        if (userData[0].IsAzure) {
            var CryptoJS = require("crypto-js");
            var SECRET_KEY = 'm@duLeMD#2k19';
            var accesscode = CryptoJS.AES.encrypt(userData[0].UserLogName + ',' + userData[0].PracticeCode + ',' + userData[0].PatientId, SECRET_KEY).toString();
            window.location.href = environment.appSetting.azurePatientPortalUrl + '?azure=1&accessCode=' + encodeURIComponent(accesscode);
            return;

        }
        localStorage.removeItem('usersession');
        localStorage.setItem('usersession', JSON.stringify(userData));
        $('#patientSelectionModal').modal("hide");
        this.router.routeReuseStrategy.shouldReuseRoute = function (future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot) {
            if (future.url.toString() === 'view' && curr.url.toString() === future.url.toString()) {
                return false;
            }
            return (future.routeConfig === curr.routeConfig);
        };
        //this.router.onSameUrlNavigation = 'reload';
        environment.UserPracticeId = userData[0].PracticeCode;
        this.userName = userData[0].PatientName;
        this.setImage();
        if (this.router.url == '/dashboard')
            this.router.navigate(['dashboard/dashboard']);
        else
            this.router.navigate(['dashboard']);

    }
    goToDashboard() {
        this.router.navigate(['dashboard']);

    }
    ngAfterViewInit() {
    }
    redirectToPage(title, fromReq, elemId?) {
        if (fromReq == 'patientforms' || fromReq == 'visits' || fromReq == 'statement') {//|| fromReq == 'educationalresources'
            localStorage.setItem('reqParam', title);
        }
        if (fromReq == 'statement') {
            $('#statements .nav li').removeClass('active');
            $('#' + title).closest('li').addClass('active');
            this.router.navigateByUrl('/dashboard/financials', { skipLocationChange: true }).then(() => {
                this.router.navigate(['dashboard', 'financials', 'statement']);
            });
        }
        if (fromReq == 'visits') {
            $('#visits .nav li').removeClass('active');
            $('#' + elemId).closest('li').addClass('active');
            this.router.navigateByUrl('/dashboard', { skipLocationChange: true }).then(() => {
                this.router.navigate(['dashboard', 'clinical', 'visitsummary']);
            });
        }
    }
}
